import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const SearchFieldMain = (props) => {
  const { isMobile, mobileMode } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import('../MobileComponents/SearchFieldMob');
        setComponent(() => module.default);
      } else {
        const module = await import('../WebComponents/SearchFieldWeb');
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? (
    <LoadedComponent {...props} mode={mobileMode} />
  ) : (
    <></>
  );
};
export default SearchFieldMain;
